
import "./loader.scss"
export default function Loader() {
  return (
    <li className="loader text-center">
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </li>
  )
}
